import { api } from "apiConnections";
import { AxiosRequestConfig } from "axios";
import RequestUrlId from "types/RequestUrlId";

const requests = {
    destroy: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.delete(`/inventory/categories/${url.id}`, config),
    fetch: (config: AxiosRequestConfig) => api.get(`/inventory/categories`, config),
    fetchAll: (config: AxiosRequestConfig) => api.get(`/inventory/categories/all`, config),
    get: (config: AxiosRequestConfig, url: RequestUrlId) =>
        api.get(`/inventory/categories/${url.id}`, config),
    store: (data: object, config: AxiosRequestConfig) =>
        api.post(`/inventory/categories`, data, config),
    update: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.put(`/inventory/categories/${url.id}`, data, config),
    patch: (data: object, config: AxiosRequestConfig, url: RequestUrlId) =>
        api.patch(`/inventory/categories/${url.id}`, data, config),
};

export default requests;
